module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.83c1ec1f.ttf";